// GENERATED by npm run species:generate. DO NOT EDIT.
import type { Species } from '@/data/species';

export const GENERATED_SPECIES_DATA: Species[] = [
  {
    id: 'chant',
    nameKey: 'chant.name',
    scientificName: 'Cantharellus cibarius',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'chant.description',
    howToKey: 'chant.howTo',
    season: 'summer-fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'mushroom',
    nameKey: 'mushroom.name',
    scientificName: 'Boletus edulis',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'mushroom.description',
    howToKey: 'mushroom.howTo',
    season: 'fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'morel',
    nameKey: 'morel.name',
    scientificName: 'Morchella spp.',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'morel.description',
    howToKey: 'morel.howTo',
    season: 'spring',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'blackberry',
    nameKey: 'blackberry.name',
    scientificName: 'Rubus fruticosus',
    category: 'berry',
    emoji: '🫐',
    descriptionKey: 'blackberry.description',
    howToKey: 'blackberry.howTo',
    season: 'summer-fall',
    habitat: 'hedgerow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'elderberry',
    nameKey: 'elderberry.name',
    scientificName: 'Sambucus nigra',
    category: 'berry',
    emoji: '🫐',
    descriptionKey: 'elderberry.description',
    howToKey: 'elderberry.howTo',
    season: 'fall',
    habitat: 'hedgerow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'nettle',
    nameKey: 'nettle.name',
    scientificName: 'Urtica dioica',
    category: 'plant',
    emoji: '🌿',
    descriptionKey: 'nettle.description',
    howToKey: 'nettle.howTo',
    season: 'spring-summer',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'dandelion',
    nameKey: 'dandelion.name',
    scientificName: 'Taraxacum officinale',
    category: 'flower',
    emoji: '🌸',
    descriptionKey: 'dandelion.description',
    howToKey: 'dandelion.howTo',
    season: 'spring-summer',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'hazelnut',
    nameKey: 'hazelnut.name',
    scientificName: 'Corylus avellana',
    category: 'nut',
    emoji: '🌰',
    descriptionKey: 'hazelnut.description',
    howToKey: 'hazelnut.howTo',
    season: 'fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'garlic',
    nameKey: 'garlic.name',
    scientificName: 'Allium ursinum',
    category: 'plant',
    emoji: '🧄',
    descriptionKey: 'garlic.description',
    howToKey: 'garlic.howTo',
    season: 'spring',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE'],
  },
  {
    id: 'chicken-of-the-woods',
    nameKey: 'chickenOfTheWoods.name',
    scientificName: 'Laetiporus sulphureus',
    category: 'mushroom',
    emoji: '🍄',
    descriptionKey: 'chickenOfTheWoods.description',
    howToKey: 'chickenOfTheWoods.howTo',
    season: 'summer-fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'oyster-mushroom',
    nameKey: 'oysterMushroom.name',
    scientificName: 'Pleurotus ostreatus',
    category: 'mushroom',
    emoji: '🍄',
    descriptionKey: 'oysterMushroom.description',
    howToKey: 'oysterMushroom.howTo',
    season: 'fall-winter',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'shiitake',
    nameKey: 'shiitake.name',
    scientificName: 'Lentinula edodes',
    category: 'mushroom',
    emoji: '🍄',
    descriptionKey: 'shiitake.description',
    howToKey: 'shiitake.howTo',
    season: 'spring-fall',
    habitat: 'forest',
  },
  {
    id: 'raspberry',
    nameKey: 'raspberry.name',
    scientificName: 'Rubus idaeus',
    category: 'berry',
    emoji: '🫐',
    descriptionKey: 'raspberry.description',
    howToKey: 'raspberry.howTo',
    season: 'summer',
    habitat: 'hedgerow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'blueberry',
    nameKey: 'blueberry.name',
    scientificName: 'Vaccinium myrtillus',
    category: 'berry',
    emoji: '🫐',
    descriptionKey: 'blueberry.description',
    howToKey: 'blueberry.howTo',
    season: 'summer-fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'strawberry',
    nameKey: 'strawberry.name',
    scientificName: 'Fragaria vesca',
    category: 'berry',
    emoji: '🍓',
    descriptionKey: 'strawberry.description',
    howToKey: 'strawberry.howTo',
    season: 'spring-summer',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'wild-mint',
    nameKey: 'wildMint.name',
    scientificName: 'Mentha spp.',
    category: 'plant',
    emoji: '🌿',
    descriptionKey: 'wildMint.description',
    howToKey: 'wildMint.howTo',
    season: 'spring-summer',
    habitat: 'wetland',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'chickweed',
    nameKey: 'chickweed.name',
    scientificName: 'Stellaria media',
    category: 'plant',
    emoji: '🌿',
    descriptionKey: 'chickweed.description',
    howToKey: 'chickweed.howTo',
    season: 'spring-fall',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'plantain',
    nameKey: 'plantain.name',
    scientificName: 'Plantago major',
    category: 'plant',
    emoji: '🌿',
    descriptionKey: 'plantain.description',
    howToKey: 'plantain.howTo',
    season: 'spring-fall',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'walnut',
    nameKey: 'walnut.name',
    scientificName: 'Juglans regia',
    category: 'nut',
    emoji: '🌰',
    descriptionKey: 'walnut.description',
    howToKey: 'walnut.howTo',
    season: 'fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'chestnut',
    nameKey: 'chestnut.name',
    scientificName: 'Castanea sativa',
    category: 'nut',
    emoji: '🌰',
    descriptionKey: 'chestnut.description',
    howToKey: 'chestnut.howTo',
    season: 'fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE'],
  },
  {
    id: 'elderflower',
    nameKey: 'elderflower.name',
    scientificName: 'Sambucus nigra',
    category: 'flower',
    emoji: '🌸',
    descriptionKey: 'elderflower.description',
    howToKey: 'elderflower.howTo',
    season: 'spring-summer',
    habitat: 'hedgerow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'daisy',
    nameKey: 'daisy.name',
    scientificName: 'Bellis perennis',
    category: 'flower',
    emoji: '🌸',
    descriptionKey: 'daisy.description',
    howToKey: 'daisy.howTo',
    season: 'spring-summer',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'violets',
    nameKey: 'violets.name',
    scientificName: 'Viola odorata',
    category: 'flower',
    emoji: '🌸',
    descriptionKey: 'violets.description',
    howToKey: 'violets.howTo',
    season: 'spring',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'amaranth',
    nameKey: 'amaranth.name',
    scientificName: 'Amaranthus retroflexus',
    category: 'plant',
    emoji: '🌿',
    descriptionKey: 'amaranth.description',
    howToKey: 'amaranth.howTo',
    season: 'spring-fall',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'artichoke',
    nameKey: 'artichoke.name',
    scientificName: 'Cynara cardunculus',
    category: 'plant',
    emoji: '🌿',
    descriptionKey: 'artichoke.description',
    howToKey: 'artichoke.howTo',
    season: 'spring-summer',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'asparagus',
    nameKey: 'asparagus.name',
    scientificName: 'Asparagus acutifolius',
    category: 'plant',
    emoji: '🌿',
    descriptionKey: 'asparagus.description',
    howToKey: 'asparagus.howTo',
    season: 'spring',
    habitat: 'hedgerow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE'],
  },
  {
    id: 'black_chant',
    nameKey: 'black_chant.name',
    scientificName: 'Craterellus cornucopioides',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'black_chant.description',
    howToKey: 'black_chant.howTo',
    season: 'fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'lingonb',
    nameKey: 'lingonb.name',
    scientificName: 'Vaccinium vitis-idaea',
    category: 'berry',
    emoji: '🫐',
    descriptionKey: 'lingonb.description',
    howToKey: 'lingonb.howTo',
    season: 'summer-fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'masterwort',
    nameKey: 'masterwort.name',
    scientificName: 'Peucedanum ostruthium',
    category: 'plant',
    emoji: '🌿',
    descriptionKey: 'masterwort.description',
    howToKey: 'masterwort.howTo',
    season: 'summer',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE'],
  },
  {
    id: 'parasol',
    nameKey: 'parasol.name',
    scientificName: 'Macrolepiota procera',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'parasol.description',
    howToKey: 'parasol.howTo',
    season: 'summer-fall',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE'],
  },
  {
    id: 'sorrel',
    nameKey: 'sorrel.name',
    scientificName: 'Rumex acetosa',
    category: 'plant',
    emoji: '🌿',
    descriptionKey: 'sorrel.description',
    howToKey: 'sorrel.howTo',
    season: 'spring-summer',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'st_george',
    nameKey: 'st_george.name',
    scientificName: 'Calocybe gambosa',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'st_george.description',
    howToKey: 'st_george.howTo',
    season: 'spring',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE'],
  },
  {
    id: 'truffle_b',
    nameKey: 'truffle_b.name',
    scientificName: 'Tuber melanosporum',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'truffle_b.description',
    howToKey: 'truffle_b.howTo',
    season: 'winter',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['SE'],
  },
  {
    id: 'bronze_bolete',
    nameKey: 'bronze_bolete.name',
    scientificName: 'Boletus aereus',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'bronze_bolete.description',
    howToKey: 'bronze_bolete.howTo',
    season: 'summer-fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE'],
  },
  {
    id: 'pine_bolete',
    nameKey: 'pine_bolete.name',
    scientificName: 'Boletus pinophilus',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'pine_bolete.description',
    howToKey: 'pine_bolete.howTo',
    season: 'spring-fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE'],
  },
  {
    id: 'summer_bolete',
    nameKey: 'summer_bolete.name',
    scientificName: 'Boletus reticulatus',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'summer_bolete.description',
    howToKey: 'summer_bolete.howTo',
    season: 'summer',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE'],
  },
  {
    id: 'pacific_chant',
    nameKey: 'pacific_chant.name',
    scientificName: 'Cantharellus formosus',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'pacific_chant.description',
    howToKey: 'pacific_chant.howTo',
    season: 'fall-winter',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['USE', 'USW'],
  },
  {
    id: 'smooth_chant',
    nameKey: 'smooth_chant.name',
    scientificName: 'Cantharellus lateritius',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'smooth_chant.description',
    howToKey: 'smooth_chant.howTo',
    season: 'summer',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['USE', 'USW'],
  },
  {
    id: 'winter_chant',
    nameKey: 'winter_chant.name',
    scientificName: 'Craterellus tubaeformis',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'winter_chant.description',
    howToKey: 'winter_chant.howTo',
    season: 'fall-winter',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'eastern_king',
    nameKey: 'eastern_king.name',
    scientificName: 'Boletus variipes',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'eastern_king.description',
    howToKey: 'eastern_king.howTo',
    season: 'summer',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['USE', 'USW'],
  },
  {
    id: 'rocky_king',
    nameKey: 'rocky_king.name',
    scientificName: 'Boletus rubriceps',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'rocky_king.description',
    howToKey: 'rocky_king.howTo',
    season: 'summer',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['USE', 'USW'],
  },
  {
    id: 'lions_mane',
    nameKey: 'lions_mane.name',
    scientificName: 'Hericium erinaceus',
    category: 'mushroom',
    emoji: '🍄',
    descriptionKey: 'lions_mane.description',
    howToKey: 'lions_mane.howTo',
    season: 'fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['USE', 'USW'],
  },
  {
    id: 'hen_of_the_woods',
    nameKey: 'hen_of_the_woods.name',
    scientificName: 'Grifola frondosa',
    category: 'mushroom',
    emoji: '🍄',
    descriptionKey: 'hen_of_the_woods.description',
    howToKey: 'hen_of_the_woods.howTo',
    season: 'fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['USE', 'USW'],
  },
  {
    id: 'saffron_milk_cap',
    nameKey: 'saffron_milk_cap.name',
    scientificName: 'Lactarius deliciosus',
    category: 'mushroom',
    emoji: '🍄',
    descriptionKey: 'saffron_milk_cap.description',
    howToKey: 'saffron_milk_cap.howTo',
    season: 'fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'hedgehog_mushroom',
    nameKey: 'hedgehog_mushroom.name',
    scientificName: 'Hydnum repandum',
    category: 'mushroom',
    emoji: '🍄',
    descriptionKey: 'hedgehog_mushroom.description',
    howToKey: 'hedgehog_mushroom.howTo',
    season: 'summer-fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'shaggy_mane',
    nameKey: 'shaggy_mane.name',
    scientificName: 'Coprinus comatus',
    category: 'mushroom',
    emoji: '🍄',
    descriptionKey: 'shaggy_mane.description',
    howToKey: 'shaggy_mane.howTo',
    season: 'spring-fall',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'giant_puffball',
    nameKey: 'giant_puffball.name',
    scientificName: 'Calvatia gigantea',
    category: 'mushroom',
    emoji: '🍄',
    descriptionKey: 'giant_puffball.description',
    howToKey: 'giant_puffball.howTo',
    season: 'summer-fall',
    habitat: 'meadow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'matsutake',
    nameKey: 'matsutake.name',
    scientificName: 'Tricholoma matsutake',
    category: 'mushroom',
    emoji: '🍄',
    descriptionKey: 'matsutake.description',
    howToKey: 'matsutake.howTo',
    season: 'fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'USE', 'USW'],
  },
  {
    id: 'ramps',
    nameKey: 'ramps.name',
    scientificName: 'Allium tricoccum',
    category: 'plant',
    emoji: '🧄',
    descriptionKey: 'ramps.description',
    howToKey: 'ramps.howTo',
    season: 'spring',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['USE', 'USW'],
  },
  {
    id: 'fiddleheads',
    nameKey: 'fiddleheads.name',
    scientificName: 'Matteuccia struthiopteris',
    category: 'plant',
    emoji: '🌿',
    descriptionKey: 'fiddleheads.description',
    howToKey: 'fiddleheads.howTo',
    season: 'spring',
    habitat: 'wetland',
    showOnMap: true,
    forecastRegions: ['USE', 'USW'],
  },
  {
    id: 'cloudberry',
    nameKey: 'cloudberry.name',
    scientificName: 'Rubus chamaemorus',
    category: 'berry',
    emoji: '🫐',
    descriptionKey: 'cloudberry.description',
    howToKey: 'cloudberry.howTo',
    season: 'summer',
    habitat: 'wetland',
    showOnMap: true,
    forecastRegions: ['NE'],
  },
  {
    id: 'huckleberry',
    nameKey: 'huckleberry.name',
    scientificName: 'Vaccinium membranaceum',
    category: 'berry',
    emoji: '🫐',
    descriptionKey: 'huckleberry.description',
    howToKey: 'huckleberry.howTo',
    season: 'summer-fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['USE', 'USW'],
  },
  {
    id: 'pawpaw',
    nameKey: 'pawpaw.name',
    scientificName: 'Asimina triloba',
    category: 'berry',
    emoji: '🥭',
    descriptionKey: 'pawpaw.description',
    howToKey: 'pawpaw.howTo',
    season: 'fall',
    habitat: 'woodland',
    showOnMap: true,
    forecastRegions: ['USE', 'USW'],
  },
  {
    id: 'rose_hips',
    nameKey: 'rose_hips.name',
    scientificName: 'Rosa canina',
    category: 'berry',
    emoji: '🌹',
    descriptionKey: 'rose_hips.description',
    howToKey: 'rose_hips.howTo',
    season: 'fall-winter',
    habitat: 'hedgerow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
  {
    id: 'sloes',
    nameKey: 'sloes.name',
    scientificName: 'Prunus spinosa',
    category: 'berry',
    emoji: '🫐',
    descriptionKey: 'sloes.description',
    howToKey: 'sloes.howTo',
    season: 'fall',
    habitat: 'hedgerow',
    showOnMap: true,
    forecastRegions: ['NE', 'SE'],
  },
  {
    id: 'sea_buckthorn',
    nameKey: 'sea_buckthorn.name',
    scientificName: 'Hippophae rhamnoides',
    category: 'berry',
    emoji: '🫐',
    descriptionKey: 'sea_buckthorn.description',
    howToKey: 'sea_buckthorn.howTo',
    season: 'fall',
    habitat: 'grassland',
    showOnMap: true,
    forecastRegions: ['NE', 'SE'],
  },
  {
    id: 'boletus',
    nameKey: 'boletus.name',
    scientificName: 'Boletus',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'boletus.description',
    howToKey: 'boletus.howTo',
    season: 'summer-fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
    compositeOf: [
      'mushroom',
      'pine_bolete',
      'bronze_bolete',
      'summer_bolete',
      'eastern_king',
      'rocky_king',
      'bay_bolete',
    ],
  },
  {
    id: 'cantharellus',
    nameKey: 'cantharellus.name',
    scientificName: 'Cantharellus',
    category: 'mushroom',
    emoji: '🍄',
    descriptionKey: 'cantharellus.description',
    howToKey: 'cantharellus.howTo',
    season: 'summer-fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
    compositeOf: [
      'chant',
      'smooth_chant',
      'pacific_chant',
      'black_chant',
      'winter_chant',
    ],
  },
  {
    id: 'bay_bolete',
    nameKey: 'bay_bolete.name',
    scientificName: 'Imleria badia',
    category: 'mushroom',
    emoji: '🍄‍🟫',
    descriptionKey: 'bay_bolete.description',
    howToKey: 'bay_bolete.howTo',
    season: 'fall',
    habitat: 'forest',
    showOnMap: true,
    forecastRegions: ['NE', 'SE', 'USE', 'USW'],
  },
];

export const GENERATED_REGION_BOUNDARIES = {
  uswMaxLongitude: -100,
  usMaxLongitude: -25,
  seMaxLatitude: 47,
} as const;
